import { useTranslation } from '@jobcost-monorepo/i18n';
import { cn } from '@jobcost-monorepo/utils';
import { XCircleIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '../../../../index';
import CheckBoxForm from '../../../CheckboxForm';
import { InputForm } from '../../../index';
import { FormFieldsLogin } from '../useLogin';

interface Props {
  loading?: boolean;
  resetPasswordLink: string;
  onSubmit: (params: FormFieldsLogin) => void;
  error?: string;
}

const LoginForm: React.FC<Props> = ({
  loading,
  resetPasswordLink,
  error,
  onSubmit,
}) => {
  const { t } = useTranslation('auth');
  const { getValues, trigger } = useFormContext<FormFieldsLogin>();
  const [show, setShow] = useState<boolean>(false);

  const handleLogin = async () => {
    const noError = await trigger();
    if (noError) onSubmit(getValues());
  };

  useEffect(() => {
    if (error?.trim().length !== 0) {
      setShow(true);
      const timeout = setTimeout(() => {
        setShow(false);
      }, 3000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [loading]);

  return (
    <form onSubmit={handleLogin}>
      <div>
        <InputForm
          name="email"
          label={t('email')}
          required
          type="email"
          errorName="email"
        />
      </div>

      <div>
        <InputForm
          name="password"
          label={t('password')}
          required
          type="password"
          errorName="password"
        />
      </div>

      <div className="mb-4">
        <CheckBoxForm
          label={t('rememberMe')}
          name="rememberMe"
          id="rememberMe"
          errorName=""
        />
      </div>

      <div className="flex items-center justify-between mb-4">
        <div className="text-sm">
          <a href={resetPasswordLink} className="font-medium">
            {t('forgotPassword')}
          </a>
        </div>
      </div>

      <div>
        <Button
          className="w-full"
          onClick={handleLogin}
          loading={loading}
          disabled={loading}
        >
          {t('signIn')}
        </Button>
      </div>

      <div className="flex h-6 mt-4 items-center text-center justify-center text-red">
        <XCircleIcon
          className={cn('h-5 w-5 text-red-400 mr-2', show ? 'block' : 'hidden')}
          aria-hidden="true"
        />
        <p className={cn(show ? 'block' : 'hidden')}>{t(`auth.${error}`)}</p>
      </div>
    </form>
  );
};

export default LoginForm;
